import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { useUser } from '../../../context/UserContext';
import { useBreadcrumb } from '../../../hooks/useBreadcrumb';
import NotificationBell from './NotificationBell';
import YearSelector from './YearSelector';
import UserChip from './UserChip';

// sobre : barre « système » gris très clair avec fine bordure basse (écran de
// composition, 2026-09-03), pour laisser l'en-tête de contexte porter la
// couleur. Par défaut, le verre dépoli du reste de l'application.
const TopBar = ({ sobre = false }) => {
    const { user, etablissementData } = useUser();
    const breadcrumb = useBreadcrumb();

    const professeur = etablissementData?.professeurs?.find(p => p.id === user?.id);
    const chef = etablissementData?.chefs?.find(c => c.id === user?.id);
    const person = professeur || chef;

    const fullName = person
        ? `${person.prenom || ''} ${person.nom || ''}`.trim()
        : (user?.username || '');

    const initials = person
        ? `${(person.prenom?.[0] || '')}${(person.nom?.[0] || '')}`.toUpperCase()
        : (user?.username?.[0] || '?').toUpperCase();

    const roleLabel = (() => {
        if (user?.role === 'chef') return 'Chef d\'établissement';
        if (!professeur) return 'Professeur';
        const tags = [];
        if (professeur.coordonateur) tags.push('Coordo');
        if (professeur.delegue_affectation) tags.push('Délégué');
        return tags.length > 0 ? tags.join(' · ') : 'Professeur';
    })();

    return (
        <header className={`sticky top-0 z-30 border-b ${
            sobre
                ? 'bg-[#F8FAFC] border-[#E6EDF5]'
                : 'bg-white/60 backdrop-blur-xl border-white/40 shadow-sm shadow-blue-900/5'
        }`}>
            <div className="px-6 lg:px-10 py-3 flex items-center justify-between gap-4">
                {/* Breadcrumb */}
                <nav className="flex items-center gap-2 text-[12.5px] text-slate-500 min-w-0">
                    <Home className="w-4 h-4 text-slate-400 shrink-0" />
                    {breadcrumb.map((segment, i) => {
                        const isLast = i === breadcrumb.length - 1;
                        return (
                            <Fragment key={`${segment.label}-${i}`}>
                                {i > 0 && <span className="text-slate-300">/</span>}
                                {segment.href && !isLast ? (
                                    <Link
                                        to={segment.href}
                                        className="hover:text-slate-700 truncate transition-colors"
                                    >
                                        {segment.label}
                                    </Link>
                                ) : (
                                    <span className={isLast
                                        ? 'font-semibold text-slate-700 truncate'
                                        : 'truncate'}>
                                        {segment.label}
                                    </span>
                                )}
                            </Fragment>
                        );
                    })}
                </nav>

                {/* Cluster droit */}
                <div className="flex items-center gap-2 shrink-0">
                    <NotificationBell />
                    <YearSelector />
                    <UserChip name={fullName} initials={initials} role={roleLabel} />
                </div>
            </div>
        </header>
    );
};

export default TopBar;
